// types
import { PaletteThemeProps } from 'types/theme';
import { PalettesProps } from '@ant-design/colors';
import { PaletteColorOptions } from '@mui/material/styles';

// ==============================|| PRESET THEME - DEFAULT ||============================== //

export default function Default(colors: PalettesProps): PaletteThemeProps {
  const { grey } = colors;
  const greyColors: PaletteColorOptions = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };
  const contrastText = '#fff';

  return {
    primary: {
      lighter: '#EDF8FF',
      100: '#D7EDFF',
      200: '#B9E1FF',
      light: '#50B5FF',
      400: '#2893FF',
      main: '#1677FF',
      dark: '#0A5CEB',
      700: '#0F4ABE',
      darker: '#134295',
      900: '#112A5A',
      contrastText
    },
    secondary: {
      lighter: greyColors[100],
      100: greyColors[100],
      200: greyColors[200],
      light: greyColors[300],
      400: greyColors[400],
      main: greyColors[500]!,
      600: greyColors[600],
      dark: greyColors[700],
      800: greyColors[800],
      darker: greyColors[900],
      A100: greyColors[0],
      A200: greyColors.A400,
      A300: greyColors.A700,
      contrastText: greyColors[0]
    },
    error: {
      lighter: '#FFF1F2',
      100: '#FDF0F2',
      200: '#FFC5CA',
      light: '#FF9DA5',
      400: '#FF6471',
      main: '#FF3546',
      dark: '#ED1527',
      700: '#C80D1D',
      darker: '#A50F1C',
      900: '#88141E',
      contrastText
    },
    warning: {
      lighter: '#FFF7ED',
      100: '#FFEED4',
      200: '#FFD9A8',
      light: '#FFBD71',
      400: '#FF8D28',
      main: '#FE7711',
      dark: '#EF5C07',
      700: '#C64308',
      darker: '#9D360F',
      900: '#7E2E10',
      contrastText: greyColors[100]
    },
    info: {
      lighter: '#F0FDFB',
      100: '#CBFCF6',
      200: '#98F7EF',
      light: '#5ECEE5',
      400: '#2BD6D3',
      main: '#13C2C2',
      dark: '#0C9295',
      700: '#0E7377',
      darker: '#105B5F',
      900: '#124C4F',
      contrastText
    },
    success: {
      lighter: '#F2FBF4',
      100: '#E1F7E6',
      200: '#C4EECD',
      light: '#96DFA5',
      400: '#61C776',
      main: '#38A34F',
      dark: '#2C8D41',
      700: '#257036',
      darker: '#22592F',
      900: '#1E4928',
      contrastText
    },
    grey: greyColors
  };
}
